/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTableColumn as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElAlert as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/alert/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { apiUsdkBatchGetGameInfo, apiUsdkSaveCallbackUrl } from '@/api/usdk';
import { URLREG } from '@/utils/reg';
import TipsModal from '@/views/pack/channel/tipsModal.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'addCallback',
  props: {
    gameInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const tipsModalRef = ref();
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const props = __props;
    const sdkInfo = ref([]);
    const oldSdkInfo = ref([]);
    // 判断是否可以编辑
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleItem = (type, scope) => {
      if (type === 'add') {
        // 如果上一个没有填值，不允许添加
        if (sdkInfo.value.length) {
          const last = sdkInfo.value[sdkInfo.value.length - 1];
          if (!last.value) {
            ElMessage({
              type: 'warning',
              message: '请完成上一个回调地址信息!'
            });
            return;
          }
        }
        sdkInfo.value.push({
          key: sdkInfo.value.length + 1,
          value: ''
        });
      } else {
        sdkInfo.value.splice(scope.$index, 1);
      }
    };
    const handleSubmit = () => {
      if (JSON.stringify(deepSdkInfo.value) === JSON.stringify(sdkInfo.value)) {
        dialogVisible.value = false;
        return;
      }
      // 根据正则 URLREG 校验value
      console.log({
        sdkInfo
      });
      let flag = false;
      let key = 0;
      if (sdkInfo.value.length) {
        sdkInfo.value.forEach(item => {
          if (!URLREG.test(item.value)) {
            flag = true;
            key = item.key;
            return;
          }
        });
      }
      if (flag) {
        ElMessage({
          type: 'warning',
          message: `回调地址【${key}】格式不正确!`
        });
        return;
      }
      tipsModalRef.value.showModal({
        editParam: ''
      });
    };
    const handleConfirm = async () => {
      const dict = {
        callbackUrl: {
          name: '支付回调地址'
        }
      };
      confirmLoading.value = true;
      const {
        Id
      } = props.gameInfo;
      const callbackUrl = {};
      sdkInfo.value.forEach(item => {
        callbackUrl[item.key] = item.value;
      });
      const params = {
        gid: Id,
        callbackUrl: JSON.stringify(callbackUrl)
      };
      const res = await apiUsdkSaveCallbackUrl(params);
      if (res.code === 0) {
        dialogVisible.value = false;
        tipsModalRef.value.closeModal();
        customDataReport({
          eventName: 'set_pay_callback_url',
          dict,
          before: {
            callbackUrl: oldSdkInfo.value
          },
          after: {
            callbackUrl: sdkInfo.value
          },
          operatePath: '出包-游戏配置-支付回调地址',
          gid: Id
        });
      }
      confirmLoading.value = false;
    };
    const formatUrl = url => {
      if (!url) return [];
      try {
        const res = JSON.parse(url);
        if (res && typeof res === 'object') {
          return Object.keys(res).map(key => ({
            key: Number(key),
            value: res[key]
          }));
        }
        return [];
      } catch (error) {
        return [{
          key: 1,
          value: url
        }];
      }
    };
    const deepSdkInfo = ref([]);
    const getGameInfo = () => {
      apiUsdkBatchGetGameInfo({
        gids: props.gameInfo.Id
      }).then(res => {
        if (res.code == 0 && res.data.length) {
          sdkInfo.value = formatUrl(res.data[0].callbackUrl);
          deepSdkInfo.value = JSON.parse(JSON.stringify(sdkInfo.value));
          oldSdkInfo.value = JSON.parse(JSON.stringify(sdkInfo.value));
        }
      });
    };
    const show = () => {
      dialogVisible.value = true;
      getGameInfo();
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_alert = __unplugin_components_0;
      const _component_el_input = __unplugin_components_1;
      const _component_el_table_column = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_table = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        "before-close": handleClose,
        title: "添加支付回调地址"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: _unref(confirmLoading),
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_alert, {
          closable: false
        }, {
          default: _withCtx(() => [_createTextVNode(" 用于游戏服务器接收支付回调地址。配置后不再读取本地配置，需向开发确认 进入正式环境前是否需要更换地址 ")]),
          _: 1
        }), _createVNode(_component_el_table, {
          ref: "tableRef",
          data: _unref(sdkInfo),
          class: "marginT20"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            property: "key",
            width: "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.key,
              "onUpdate:modelValue": $event => scope.row.key = $event,
              modelModifiers: {
                trim: true
              },
              disabled: "",
              maxlength: "100"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "回调地址",
            property: "value"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.value,
              "onUpdate:modelValue": $event => scope.row.value = $event,
              modelModifiers: {
                trim: true
              },
              maxlength: "500"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              link: "",
              size: "small",
              type: "danger",
              onClick: $event => handleItem('del', scope)
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_button, {
          class: "mt-4 marginT10 width100",
          onClick: _cache[0] || (_cache[0] = $event => handleItem('add'))
        }, {
          default: _withCtx(() => [_createTextVNode("添加账号")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(TipsModal, {
        ref_key: "tipsModalRef",
        ref: tipsModalRef,
        onCancel: handleClose,
        onOk: handleConfirm
      }, null, 512)], 64);
    };
  }
});